export const SendIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M24.0932 11.3467L12.6799 5.64C5.0132 1.8 1.86653 4.94666 5.70653 12.6133L6.86653 14.9333C7.19986 15.6133 7.19986 16.4 6.86653 17.08L5.70653 19.3867C1.86653 27.0533 4.99986 30.2 12.6799 26.36L24.0932 20.6533C29.2132 18.0933 29.2132 13.9067 24.0932 11.3467ZM19.7865 17H12.5865C12.0399 17 11.5865 16.5467 11.5865 16C11.5865 15.4533 12.0399 15 12.5865 15H19.7865C20.3332 15 20.7865 15.4533 20.7865 16C20.7865 16.5467 20.3332 17 19.7865 17Z"
      fill="#00B8E0"
    />
  </svg>
);
export const SendIconOutlined = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.3453 4.39766C22.3253 4.26579 23.0353 5.30935 22.5528 6.17249L14.7502 20.13C14.2435 21.0365 12.9027 20.915 12.5671 19.9322L10.5438 14.0065C10.3693 13.4955 10.0601 13.0411 9.64889 12.6911L4.88012 8.63333C4.08923 7.96035 4.46856 6.66862 5.49775 6.53013L21.3453 4.39766Z"
      stroke="white"
      strokeOpacity="0.58"
      strokeWidth="1.5"
    />
    <path
      d="M11.2056 9.17418L9.25684 10.5"
      stroke="white"
      strokeOpacity="0.58"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
